import { render } from "./_Index.vue?vue&type=template&id=6dc529aa&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=6dc529aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dc529aa"

export default script